import { useTranslation } from '@/hooks/useTranslation';

interface MandatoryFieldLabelProps {
  /** Key of the process field, as listed in `mandatoryFields`. */
  fieldKey: string;
  label: string;
  /** `id` of the input the label belongs to. */
  htmlFor: string;
  mandatoryFields: string[];
  onToggleMandatory: (fieldKey: string) => void;
}

/** Label row of a process field, with its "show to operator" checkbox on the right. */
export function MandatoryFieldLabel({
  fieldKey,
  label,
  htmlFor,
  mandatoryFields,
  onToggleMandatory,
}: MandatoryFieldLabelProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between gap-2 mb-1">
      <label htmlFor={htmlFor} className="text-sm font-medium text-foreground">
        {label}
      </label>
      <label className="flex items-center gap-1.5 cursor-pointer text-xs text-muted-foreground">
        <input
          type="checkbox"
          checked={mandatoryFields.includes(fieldKey)}
          onChange={() => onToggleMandatory(fieldKey)}
          className="h-3.5 w-3.5 rounded border-border accent-primary"
        />
        {t('traceability.processManager.form.showToOperator')}
      </label>
    </div>
  );
}
